import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord, StateModel } from '@common/models';

export interface ISalesItemPriceRuleStateModel extends IModel {
  salesItemPriceRuleStateId: number;
  salesItemPriceRuleId: number;
  stateId: number;
  state: StateModel;
}

export class SalesItemPriceRuleStateModel
  extends Model
  implements ModelRecord<ISalesItemPriceRuleStateModel>
{
  salesItemPriceRuleStateId: number;
  salesItemPriceRuleId: number;
  stateId: number;
  state: StateModel;

  constructor(params?: Partial<ISalesItemPriceRuleStateModel>) {
    super(params);
    this.salesItemPriceRuleStateId = defaultTo(
      params?.salesItemPriceRuleStateId,
      0,
    );
    this.salesItemPriceRuleId = defaultTo(params?.salesItemPriceRuleId, 0);
    this.stateId = defaultTo(params?.stateId, 0);
    this.state = params?.state
      ? new StateModel(params.state)
      : new StateModel();
  }
}
